import { detect } from 'detect-browser';

import { Device } from './graphql/graphql';

export const BROWSER = detect();
export const DEVICE = (BROWSER?.os === 'iOS' || BROWSER?.os === 'Mac OS') ? Device.Apple : Device.Google;
